import Logo from './Logo';
export default Logo;


// WEBPACK FOOTER //
// /src/components/UiComponents/Logo/index.js